/**
 * @param language 'en' as default
 */
export default function getNrgSinsBlogPostLink(language?: string): string {
  switch (language) {
    default:
      return 'https://medium.com/@cakedefi/important-staking-updates-on-sins-and-nrg-8b42df1b97fa';
  }
}
